export type Validator = (value?: string) => boolean

export const required: Validator = value => !!value

// Source: https://stackoverflow.com/questions/201323/how-to-validate-an-email-address-using-a-regular-expression
export const email: Validator = value =>
  !!value &&
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
    value
  )

export const maxLength =
  (length: number): Validator =>
  value =>
    !value || value.length <= length

export const combineValidators =
  (...args: Array<Validator>): Validator =>
  value =>
    args.every(validator => validator(value))
